export const GET_INVESTMENT_TRANSACTIONS_API_REQUEST =
  'GET_INVESTMENT_TRANSACTIONS_API_REQUEST';
export const GET_INVESTMENT_TRANSACTIONS_API_SUCCESS =
  'GET_INVESTMENT_TRANSACTIONS_API_SUCCESS';
export const GET_INVESTMENT_TRANSACTIONS_API_ERROR =
  'GET_INVESTMENT_TRANSACTIONS_API_ERROR';
